"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DropdownImage = _interopRequireDefault(require("./DropdownImage"));

var _excluded = ["customClass", "href", "onClick", "title", "description", "variant", "value", "image", "icon", "key"];

var DropdownItem = function DropdownItem(props) {
  var customClass = props.customClass,
      href = props.href,
      _onClick = props.onClick,
      title = props.title,
      description = props.description,
      variant = props.variant,
      value = props.value,
      image = props.image,
      icon = props.icon,
      key = props.key,
      restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _classnames.default)(variant ? 'control-dropdown__item--' + variant : '', image ? 'control-dropdown__item--with_image' : '', customClass);
  return (0, _preact.h)("a", (0, _extends2.default)({}, restProps, {
    className: classes,
    href: (0, _absoluteUrlRuntime.resolveUrl)(href),
    onClick: function onClick(e) {
      if (typeof _onClick === 'function') {
        _onClick(e);
      }
    },
    value: value,
    "data-value": title,
    key: key,
    role: _onClick ? 'button' : undefined
  }), image && (0, _preact.h)(_DropdownImage.default, {
    image: image
  }), icon && (0, _preact.h)("span", {
    className: "dropdown-item__icon"
  }, icon), title && description ? (0, _preact.h)("div", {
    className: "dropdown-item__content"
  }, (0, _preact.h)("div", {
    className: "dropdown-item__title"
  }, title), (0, _preact.h)("div", {
    className: "dropdown-item__description"
  }, description)) : title);
};

var _default = DropdownItem;
exports.default = _default;